import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'

import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue);


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/bootstrapvue.js